function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.6
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint0_linear)",
  d: "M41.8057 6.74347C38.0681 1.60389 30.8762 0.464286 25.7408 4.1946C20.6012 7.93116 19.4658 15.1189 23.1961 20.2532C26.9316 25.3959 34.1236 26.5334 39.259 22.8021C44.3995 19.0666 45.5329 11.8789 41.8057 6.74347Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint1_linear)",
  d: "M40.5375 7.66536C37.308 3.22729 31.0967 2.2414 26.6629 5.46359C22.2248 8.69205 21.2431 14.8991 24.4642 19.333C27.6916 23.7742 33.9028 24.7569 38.3378 21.5358C42.7759 18.3073 43.7555 12.0993 40.5375 7.66536Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint2_linear)",
  d: "M34.0691 15.6521C34.067 15.6281 34.067 15.603 34.0648 15.5789C33.8139 13.2046 31.4407 9.61758 31.4407 9.61758V9.62281C31.2985 9.34679 31.0162 9.15967 30.6837 9.15967C30.3586 9.15967 30.0847 9.34679 29.9352 9.61758H29.9332C29.9332 9.61758 27.5579 13.2046 27.31 15.5789C27.308 15.603 27.3048 15.6281 27.3028 15.6521C27.2965 15.7577 27.2881 15.8581 27.2881 15.9595C27.2881 17.834 28.8082 19.3584 30.6827 19.3584C32.5625 19.3584 34.0858 17.834 34.0858 15.9595C34.0879 15.8581 34.0858 15.7567 34.0691 15.6521Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint3_linear)",
  d: "M37.6938 13.0532C37.6918 13.0375 37.6906 13.0239 37.6876 13.0093C37.5391 11.5864 36.1141 9.42955 36.1141 9.42955V9.43478C36.0294 9.27063 35.8622 9.15771 35.6614 9.15771C35.4649 9.15771 35.2986 9.26958 35.2098 9.43162V9.42952C35.2098 9.42952 33.7869 11.5863 33.6373 13.0093C33.6353 13.0239 33.6353 13.0375 33.6353 13.0532C33.6248 13.1138 33.6206 13.1776 33.6206 13.2372C33.6206 14.3631 34.5364 15.2769 35.6604 15.2769C36.7864 15.2769 37.699 14.3631 37.699 13.2372C37.7011 13.1776 37.6958 13.1139 37.6938 13.0532Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint4_linear)",
  d: "M35.6624 9.15857C35.8621 9.15857 36.0304 9.27043 36.1151 9.43564V9.43041C36.1151 9.43041 37.5401 11.5872 37.6885 13.0102C37.6917 13.0248 37.6927 13.0384 37.6948 13.0541C37.6968 13.1147 37.702 13.1785 37.702 13.2381C37.702 14.364 36.7893 15.2778 35.6634 15.2778C34.5396 15.2778 33.6236 14.364 33.6236 13.2381C33.6236 13.1785 33.6278 13.1147 33.6383 13.0541C33.6383 13.0384 33.6383 13.0248 33.6403 13.0102C33.7898 11.5873 35.2128 9.43041 35.2128 9.43041V9.43251C35.2996 9.27043 35.4658 9.15857 35.6624 9.15857ZM35.6625 8.07129C35.1073 8.07129 34.596 8.35774 34.3107 8.82822L34.3023 8.8324C34.1434 9.07287 32.7268 11.2548 32.5584 12.8972C32.5564 12.9192 32.549 12.9464 32.548 12.9798C32.5395 13.0467 32.5344 13.144 32.5344 13.2381C32.5344 14.9611 33.9385 16.3662 35.6614 16.3662C37.3865 16.3662 38.7895 14.9611 38.7895 13.2381C38.7895 13.1482 38.7832 13.052 38.7727 12.9568L38.7685 12.8899C38.6002 11.2569 37.1856 9.0781 37.0205 8.8324C36.7382 8.35774 36.2228 8.07129 35.6625 8.07129Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint5_linear)",
  d: "M28.9876 13.2873C29.0041 13.0965 29.0041 12.896 28.9876 12.6997C28.9547 12.2604 28.8462 11.8308 28.6568 11.493L23.9632 3.38805C23.9358 3.31256 23.8822 3.24804 23.8355 3.18214L22.854 1.49086C22.4023 0.669935 21.2053 0 20.2759 0H18.2689H10.7322H8.72378C7.79715 0 6.59868 0.669935 6.14701 1.49086L5.16685 3.18214C5.1188 3.24942 5.06525 3.31394 5.0392 3.38805L0.344205 11.493C0.160246 11.8225 0.0517816 12.2412 0.0133643 12.6723C-0.00448271 12.8865 -0.00448271 13.1033 0.0133643 13.3216C0.050441 13.7527 0.158864 14.1659 0.344205 14.4954L1.60992 16.6726L5.03781 22.6113C5.08587 22.7239 5.14351 22.8282 5.22588 22.9202C5.23413 22.934 5.24921 22.9422 5.25747 22.9573L6.15392 24.4962C6.60421 25.3226 7.79715 25.9981 8.73752 25.9981H10.761H18.24H20.2635C21.2039 25.9981 22.3996 25.3226 22.8485 24.4962L23.745 22.9573C23.7546 22.9408 23.7669 22.9326 23.7779 22.9202C23.8603 22.8296 23.9179 22.7239 23.9646 22.6113L27.3925 16.6726L28.6582 14.4954C28.8462 14.159 28.9533 13.7321 28.9876 13.2873Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint6_linear)",
  d: "M26.8433 13.2463C26.8584 13.0843 26.8584 12.9127 26.8433 12.7466C26.8159 12.3705 26.7239 12.004 26.5605 11.717L22.563 4.81046C22.5396 4.74732 22.493 4.69101 22.4532 4.63747L21.6171 3.1919C21.2327 2.49315 20.2114 1.9248 19.4206 1.9248H17.7115H11.2881H9.57626C8.78554 1.9248 7.76553 2.49315 7.38115 3.1919L6.54649 4.63747C6.50531 4.69101 6.45863 4.74728 6.43668 4.81046L2.43634 11.717C2.28121 11.9984 2.18649 12.3554 2.15628 12.7219C2.13982 12.9045 2.13982 13.0898 2.15628 13.2765C2.18649 13.6416 2.28121 13.9945 2.43634 14.2745L3.514 16.1305L6.4353 21.1934C6.47786 21.2895 6.52592 21.376 6.59592 21.4556C6.60279 21.4652 6.61515 21.4721 6.62336 21.4844L7.38664 22.7968C7.77102 23.4997 8.78688 24.0749 9.58861 24.0749H11.3115H17.684H19.4069C20.2086 24.0749 21.2272 23.4997 21.6089 22.7968L22.3735 21.4844C22.3818 21.4707 22.3927 21.4638 22.401 21.4556C22.471 21.3746 22.519 21.2895 22.5616 21.1934L25.4815 16.1305L26.5578 14.2745C26.7239 13.9877 26.8159 13.6238 26.8433 13.2463Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint7_linear)",
  d: "M19.8379 11.4796L16.0229 11.4768V7.66181C16.0229 6.82165 15.3406 6.13525 14.4991 6.13525C13.6576 6.13525 12.9753 6.82165 12.9753 7.66181V11.4741H9.16169H9.15892C8.31877 11.4741 7.63647 12.155 7.63647 12.9951C7.63647 13.8408 8.31739 14.5189 9.15892 14.5189L12.9753 14.5217V18.3367C12.9753 19.1796 13.6589 19.8605 14.4991 19.8605C15.342 19.8605 16.0229 19.1796 16.0229 18.3367V14.5244H19.8379C20.6794 14.5244 21.363 13.8435 21.363 13.0034C21.3645 12.1591 20.6808 11.4796 19.8379 11.4796Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
});

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  y2: -0.851704,
  x2: 77.4251,
  y1: 32.9981,
  x1: 45.9332,
  id: "paint0_linear"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#17E2CF"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5181FD",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  y2: 2.37251,
  x2: -3.36718,
  y1: -48.0726,
  x1: 42.3705,
  id: "paint1_linear"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#173048"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5181FD",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  y2: 23.5639,
  x2: 11.7998,
  y1: 12.6242,
  x1: 24.0083,
  id: "paint2_linear"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#17E2CF"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5181FD",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  y2: 25.0311,
  x2: 14.7546,
  y1: 14.0906,
  x1: 26.9637,
  id: "paint3_linear"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#17E2CF"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5181FD",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  y2: -19.54,
  x2: -5.67572,
  y1: -54.3668,
  x1: 49.8579,
  id: "paint4_linear"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#173048"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5181FD",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  y2: 2.25199,
  x2: 46.1278,
  y1: 43.7191,
  x1: 23.7161,
  id: "paint5_linear"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5181FD"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#17E2CF",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  y2: 16.018,
  x2: 33.259,
  y1: 51.3511,
  x1: 14.1672,
  id: "paint6_linear"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#173048"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5181FD",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  y2: 31.8071,
  x2: -3.43955,
  y1: 7.65239,
  x1: 2.98989,
  id: "paint7_linear"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#17E2CF"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5181FD",
  offset: 1
})));

var SvgIconAddLiquidity = function SvgIconAddLiquidity(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 44 26",
    height: 26,
    width: 44,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconAddLiquidity, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Icon_Add_Liquidity.208c772d.svg";
export { ForwardRef as ReactComponent };